import useCachedSelectionList from '../base/useCachedList';
import { useFindProfessionalBodiesForSelectionLazy } from './useFindProfessionalBodiesForSelection';

const useCachedProfessionalBodiesList = () => {
  return useCachedSelectionList(
    'professionalBodiesList',
    useFindProfessionalBodiesForSelectionLazy
  );
};

export default useCachedProfessionalBodiesList;
